import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";

interface ArticleCardData {
  slug: string;
  title: string;
  description: string;
  readTime: string;
  image: string;
}

const articleCards: ArticleCardData[] = [
  {
    slug: "/article/pandabuy-sheet-shoes-guide",
    title: "Best Shoe Finds in Pandabuy Sheets",
    description: "Master the sneaker section — Dunks, runners, and designer alternatives rated and reviewed.",
    readTime: "8 min",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20premium%20white%20leather%20sneakers%20on%20polished%20concrete%20floor%20with%20natural%20window%20light%20casting%20soft%20shadows%20editorial%20footwear%20photography%20high%20contrast%20clean%20modern%20aesthetic%20professional%20product%20styling&width=600&height=400&seq=seo-card-shoes&orientation=landscape"
  },
  {
    slug: "/article/pandabuy-sheet-hoodies-guide",
    title: "Hoodies & Sweaters Spreadsheet Guide",
    description: "Find the coziest Essentials, streetwear, and designer hoodie alternatives in any pandabuy sheet.",
    readTime: "7 min",
    image: "https://readdy.ai/api/search-image?query=Oversized%20grey%20hoodie%20draped%20casually%20over%20a%20vintage%20wooden%20chair%20in%20a%20sunlit%20loft%20apartment%20golden%20hour%20warm%20light%20streaming%20through%20large%20windows%20cozy%20urban%20lifestyle%20photography%20textured%20fabric%20details&width=600&height=400&seq=seo-card-hoodies&orientation=landscape"
  },
  {
    slug: "/article/pandabuy-sheet-jackets-guide",
    title: "Jackets & Outerwear Buying Guide",
    description: "Bombers, puffers, leather — how to spot premium jackets in pandabuyspreadsheet lists.",
    readTime: "9 min",
    image: "https://readdy.ai/api/search-image?query=Premium%20black%20leather%20biker%20jacket%20elegantly%20draped%20over%20an%20antique%20brass%20coat%20stand%20against%20exposed%20brick%20wall%20dramatic%20side%20lighting%20from%20nearby%20window%20luxury%20editorial%20fashion%20photography%20rich%20textures&width=600&height=400&seq=seo-card-jackets&orientation=landscape"
  },
  {
    slug: "/article/pandabuy-sheet-accessories-guide",
    title: "Accessories: Watches, Bags & Jewelry",
    description: "Hidden gems in the accessories category — luxury watch alternatives and designer-inspired pieces.",
    readTime: "8 min",
    image: "https://readdy.ai/api/search-image?query=Elegant%20wrist%20wearing%20a%20sleek%20silver%20watch%20and%20minimalist%20bracelet%20resting%20on%20a%20dark%20wooden%20table%20with%20a%20coffee%20cup%20nearby%20morning%20sunlight%20lifestyle%20close-up%20editorial%20photography%20warm%20inviting%20atmosphere&width=600&height=400&seq=seo-card-accessories&orientation=landscape"
  },
  {
    slug: "/article/pandabuy-sheet-budget-finds",
    title: "Best Budget Finds Under $50",
    description: "Top-quality pandabuy sheet items that deliver premium vibes without the premium price tag.",
    readTime: "7 min",
    image: "https://readdy.ai/api/search-image?query=Various%20fashion%20and%20lifestyle%20items%20spilling%20out%20of%20a%20premium%20kraft%20paper%20shopping%20bag%20on%20a%20white%20desk%20unboxing%20flat%20lay%20concept%20bright%20overhead%20studio%20lighting%20commercial%20product%20photography%20clean%20crisp%20details&width=600&height=400&seq=seo-card-budget&orientation=landscape"
  },
  {
    slug: "/article/pandabuy-sheet-viral-tiktok",
    title: "Viral TikTok Spreadsheet Finds",
    description: "Stay ahead of the trends — the most viral pandabuyspreadsheet items blowing up on social media.",
    readTime: "7 min",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20TikTok%20fashion%20haul%20video%20with%20shopping%20bags%20and%20trendy%20clothing%20items%20scattered%20on%20a%20pink%20neon%20lit%20desk%20modern%20Gen%20Z%20social%20media%20lifestyle%20photography%20vibrant%20energetic%20creative%20studio%20setup&width=600&height=400&seq=seo-card-tiktok&orientation=landscape"
  },
  {
    slug: "/article/pandabuy-sheet-quality-tips",
    title: "Expert Quality Check Strategies",
    description: "Learn to read quality scores, analyze reviews, and identify top-tier items in any spreadsheet.",
    readTime: "10 min",
    image: "https://readdy.ai/api/search-image?query=Professional%20fashion%20designer%20examining%20fabric%20swatches%20and%20clothing%20details%20with%20a%20magnifying%20loupe%20on%20a%20cutting%20table%20in%20a%20bright%20modern%20atelier%20studio%20quality%20control%20concept%20photography%20precise%20focused%20elegant&width=600&height=400&seq=seo-card-quality&orientation=landscape"
  },
  {
    slug: "/article/pandabuy-sheet-beginner-guide",
    title: "Complete Beginner's Starter Guide",
    description: "Everything new users need to know — from first spreadsheet browse to first successful order.",
    readTime: "11 min",
    image: "https://readdy.ai/api/search-image?query=Young%20adult%20sitting%20at%20a%20clean%20white%20desk%20with%20an%20open%20laptop%20showing%20a%20colorful%20spreadsheet%20next%20to%20a%20steaming%20coffee%20cup%20and%20a%20potted%20plant%20bright%20morning%20sunlight%20streaming%20through%20window%20beginner%20friendly%20workspace%20warm%20inviting%20educational%20atmosphere&width=600&height=400&seq=seo-card-beginner&orientation=landscape"
  },
  {
    slug: "/article/pandabuy-sheet-trending-2026",
    title: "2026 Trending Categories & Items",
    description: "Quiet luxury, technical fabrics, and vintage revival — what is hot in pandabuy sheets this year.",
    readTime: "8 min",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20fashion%20trend%20moodboard%20with%20magazine%20cutouts%20fabric%20swatches%20color%20palettes%20and%20stylish%20clothing%20items%20arranged%20on%20a%20large%20white%20inspiration%20board%20in%20a%20bright%20creative%20studio%20space%20forward%20looking%20aesthetic%20trend%20forecasting%20concept&width=600&height=400&seq=seo-card-trending&orientation=landscape"
  }
];

export default function SEOArticlesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionTitle
          title="Pandabuy Spreadsheet Guides & Tips"
          subtitle="In-depth articles to help you master every category and get the most from your pandabuy sheet"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((article, idx) => (
            <Link
              key={idx}
              to={article.slug}
              className="group block bg-white rounded-2xl overflow-hidden hover:shadow-md transition-shadow duration-300"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
                <span className="absolute bottom-2 right-3 text-[10px] text-white/75 bg-black/40 backdrop-blur-sm px-2 py-0.5 rounded-full">
                  {article.readTime}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-xs text-primary-600 font-medium">
                  Read Article
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}